/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientTargetDataModel } from '../../models/patient-target-data-model';

export interface SavePatientTargetData$Params {
  addedManually?: boolean;
      body?: PatientTargetDataModel
}

export function SavePatientTargetData(http: HttpClient, rootUrl: string, params?: SavePatientTargetData$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientTargetDataModel>> {
  const rb = new RequestBuilder(rootUrl, SavePatientTargetData.PATH, 'post');
  if (params) {
    rb.query('addedManually', params.addedManually, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientTargetDataModel>;
    })
  );
}

SavePatientTargetData.PATH = '/api/Staff/SavePatientTargetData';
